<template>
  <FormModal v-if="showPopup" :closePopup="closePopup" />

  <div>
    <Navbar :openPopup="openPopup" />
    <PageTitle2 :data="{ pageTitle: 'Become A Partner' }" />
    <!-- <BecomePartner />
    <Contact /> -->
    <Featuresist />
    <!-- <Features /> -->
     <WhyPartner :openPopup="openPopup"/>
      <IndustriesWeServe />
       <Technologies-Partner />
    <!-- <Funfacts /> -->
    <!-- <TeamTwo /> -->
    <!-- <Team /> -->
    <!-- <ServiceTeam :data="technologies" /> -->
    <!-- <TechnoloyWeexpert :data="technologies"/> -->
    <div class="blog-become-partner"> 
         <Blog /> 
         </div>
    <!-- <Screenshots /> -->
    <SoftwareIntegrations />
    <!-- <Faq /> -->
    <FooterStyleFour />
  </div>
</template>
<style>

@media screen and (max-width: 767px) {
.blog-become-partner .section-title {
    margin-bottom: 25px;
}
.blog-become-partner {
    padding-bottom: 30px;
}
}

</style>

<script>
import Navbar from "../Layout/Navbar";
import PageTitle2 from "../Common/PageTitle2.vue";
import BecomePartner from "../BecomePartner/BecomePartner";
import Contact from "../BecomePartner/Contact.vue";
import Featuresist from "../BecomePartner/Featuresist.vue";

import Features from "../HomeEight/Features";
import TeamTwo from "../TeamTwo/Team.vue";
import Blog from "../BlogOne/Blog";
import Team from "../TeamOne/Team.vue";
import Screenshots from "../HomeFour/Screenshots";
import SoftwareIntegrations from "../AboutOne/SoftwareIntegrations";
import Faq from "../Faq/Faq";
import FooterStyleFour from "../Layout/FooterStyleFour";
import TechnoloyWeexpert from "./BecomePatner/TechnoloyWeexpert.vue";
import axios from "axios";
import FormModal from "../HomeThree/FormModal.vue";
import ServiceTeam from "./Homepage/ServiceTeam.vue";
import Funfacts from "../AboutOne/Funfacts.vue";
import WhyPartner from "../BecomePartner/WhyPartner.vue";
import IndustriesWeServe from "../BecomePartner/IndustriesServe.vue";
import TechnologiesPartner from "../BecomePartner/TechnologiesPartner.vue";


export default {
  name: "BecomePartnerPage",
  components: {
    Navbar,
    PageTitle2,
    BecomePartner,
    Contact,
    Features,
    WhyPartner,
    IndustriesWeServe,
    TechnologiesPartner,
    TeamTwo,
    Team,
    Blog,
    Screenshots,
    SoftwareIntegrations,
    Faq,
    FooterStyleFour,
    TechnoloyWeexpert,
    FormModal,
    Featuresist,
    ServiceTeam,
    Funfacts
  },
  data() {
    return {
      baseUrl: "https://content.meander.software/",
      // techData: [],
      technologies: [],
      isLoading: false,
      showPopup: false,
    };
  },
  async mounted() {
    // await this.getData2();

    await this.gettitle();
    await this.getData();
  },

  methods: {
    openPopup() {
      this.showPopup = true;
    },
    closePopup() {
      this.showPopup = false;
    },
    async gettitle() {
      // Set comprehensive SEO meta tags
      document.title = "Become a Partner - Join Our Network | Meander Software";
      
      // Helper to set or update a meta tag
      function setMeta(name, content, attr = 'name') {
        let element = document.querySelector(`meta[${attr}="${name}"]`);
        if (!element) {
          element = document.createElement('meta');
          element.setAttribute(attr, name);
          document.head.appendChild(element);
        }
        element.setAttribute('content', content || '');
      }

      // Set basic meta tags
      setMeta('title', 'Become a Partner - Join Our Network | Meander Software');
      setMeta('description', 'Partner with Meander Software and expand your business opportunities. Join our network of technology partners and grow together in the software development industry.');
      setMeta('keywords', 'become a partner, software partnership, technology partners, business partnership, software development partners, meander software partners');

      // Open Graph tags
      setMeta('og:title', 'Become a Partner - Join Our Network | Meander Software', 'property');
      setMeta('og:description', 'Partner with Meander Software and expand your business opportunities. Join our network of technology partners and grow together in the software development industry.', 'property');
      setMeta('og:type', 'website', 'property');
      setMeta('og:url', window.location.href, 'property');
      setMeta('og:image', 'https://meander.software/og-default-image.jpg', 'property');
      setMeta('og:image:width', '1200', 'property');
      setMeta('og:image:height', '630', 'property');
      setMeta('og:image:alt', 'Become a Partner - Join Our Network | Meander Software', 'property');

      // Twitter Card tags
      setMeta('twitter:title', 'Become a Partner - Join Our Network | Meander Software', 'name');
      setMeta('twitter:description', 'Partner with Meander Software and expand your business opportunities. Join our network of technology partners and grow together in the software development industry.', 'name');
      setMeta('twitter:image', 'https://meander.software/og-default-image.jpg', 'name');
      setMeta('twitter:image:alt', 'Become a Partner - Join Our Network | Meander Software', 'name');
      setMeta('twitter:card', 'summary_large_image', 'name');
      setMeta('twitter:site', '@meandersoftware', 'name');
      setMeta('twitter:creator', '@meandersoftware', 'name');

      // Update canonical URL
      let canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) {
        canonical.setAttribute('href', window.location.href);
      } else {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        canonical.setAttribute('href', window.location.href);
        document.head.appendChild(canonical);
      }
    },
    async getData() {
      try {
        const response = await axios.get(
          `${this.$baseUrl}/ms-services?populate=ms_services_technologies_experts.image,ms_services_client_technologies.technologies`
        );
        const { data } = response;
        this.technologies = data.data;
      } catch (error) {
        console.error(error);
      }
    },
    // async getData() {
    //   try {
    //     const response = await axios.get(
    //       `${this.$baseUrl}/ms-services-technologies-experts?populate=*`
    //     );
    //     const { data } = response;
    //     this.technologies = data.data;
    //   } catch (error) {
    //     console.error(error);
    //   }
    // },
    // async getData2() {
    //   try {
    //     const response = await axios.get(
    //       `${this.$baseUrl}/ms-services?populate=ms_services_technologies_experts.image,ms_services_client_technologies.technologies`
    //     );
    //     const { data } = response;
    //     this.techData = data.data;
    //     document.title = "Best Software Company in US & India.";
    //   } catch (error) {
    //     console.error(error);
    //   }
    // },
  },
};
</script>
